import React from 'react';
import { Pressable, StyleSheet, useWindowDimensions } from 'react-native';
import { DNABox, DNACard, DNAText } from '@alucio/lux-ui';
import DNAPopover from 'src/components/DNA/Popover/DNAPopover';
import { normalizeDocumentSummary } from './DNADocumentSummary.utils';

const styles = StyleSheet.create({
  anchor: {
    width: '100%',
  },
  popover: {
    width: 360,
    padding: 16,
  },
});

interface DNADocumentSummaryPreviewProps {
  summary?: string;
  onPress: () => void;
}

const DNADocumentSummaryPreview: React.FC<DNADocumentSummaryPreviewProps> = ({ summary, onPress }) => {
  const { width } = useWindowDimensions();
  const text = normalizeDocumentSummary(summary);
  if (!text) return null;

  const preview = (
    <DNAText status="tertiary" ellipsizeMode="tail" numberOfLines={2} testID="document-gridlist-summary">
      {text}
    </DNAText>
  );

  return (
    <DNAPopover
      type="preview"
      placement="top-start"
      trigger="mouseenter focusin"
      fill
      interactive
    >
      <DNAPopover.Anchor style={styles.anchor}>
        <Pressable
          style={styles.anchor}
          accessibilityRole="button"
          accessibilityLabel="Preview document"
          onPress={event => {
            event.stopPropagation();
            onPress();
          }}
        >
          {preview}
        </Pressable>
      </DNAPopover.Anchor>
      <DNAPopover.Content>
        <DNACard appearance="float" style={[styles.popover, { maxWidth: width - 32 }]}>
          <DNABox appearance="col" spacing="xs">
            <DNAText status="brand" bold>SUMMARY</DNAText>
            <DNAText>{text}</DNAText>
          </DNABox>
        </DNACard>
      </DNAPopover.Content>
    </DNAPopover>
  );
};

export default DNADocumentSummaryPreview;
